import type { AppCreateClass } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"

interface Payload {}

export default function createClassGoToTemplateChooserAction(payload: Payload): PreparedAction {
  return {
    name: "CREATE_CLASS_GO_TO_TEMPLATE_CHOOSER",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppCreateClass = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "course_create",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "navigating",

    adverbial_object_type: "screen",
    adverbial_object_id: "template_chooser",
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com"],
  }
  return createNarrative({
    title: "Choose Template",
    description: `Creating a class from the Planner`,
    titleForAnalytics: "Create Class - Go To Template Chooser",
    newAnalyticsEvents: [newEvent],
  })
}
